module.exports = __webpack_public_path__ + "img/icon3.8b4c3c13.png";